"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType[MessageType["FINISHED_ASSIGNMENT"] = 0] = "FINISHED_ASSIGNMENT";
    MessageType[MessageType["ADDED_SUBMISSION_COMMENT"] = 1] = "ADDED_SUBMISSION_COMMENT";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=messageType.enum.js.map